import { ArrowDownFillIcon, ArrowUpFillIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'

import { getPercentText } from 'features/reporting'

const getPercentageDescription = (currentCount, pastCount) => {
  const diff = currentCount - pastCount
  const absolutePercentDiff = Math.abs(diff / pastCount)
  const percent = pastCount === 0 ? '0%' : getPercentText(absolutePercentDiff)
  const Icon = diff < 0 ? <ArrowDownFillIcon /> : <ArrowUpFillIcon />

  return { percent, Icon }
}

export const Trend = ({ currentCount, pastCount }) => {
  const { percent, Icon } = getPercentageDescription(currentCount, pastCount)

  return (
    <BodyText size="medium" color="muted">
      {Icon}
      {' '}
      {percent}
    </BodyText>
  )
}
